import "core-js/modules/es.array.slice.js";
//@ts-expect-error ToDo: fix this
export var capitalize = function capitalize(str) {
  return str && typeof str === 'string' ? str[0].toUpperCase() + str.slice(1) : str;
};